import {ApplicationRef, EnvironmentInjector, NgZone} from '@angular/core';
import {QueryClientProvider} from '@tanstack/react-query';
import {RouterProvider} from '@tanstack/react-router';
import {createRoot} from 'react-dom/client';
import {queryClient} from '../react/tanstack/query-client';
import {AngularContext} from './angular-host/angular-host';
import {getAppRouter} from './router';

export function mountReactApp(injector: EnvironmentInjector): void {
  const ngZone = injector.get(NgZone);
  const angular = {injector, appRef: injector.get(ApplicationRef), ngZone};

  ngZone.runOutsideAngular(() => {
    const router = getAppRouter();
    createRoot(document.getElementById('content-root')).render(
      <AngularContext.Provider value={angular}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router}/>
        </QueryClientProvider>
      </AngularContext.Provider>,
    );
  });
}
